import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Grid from '@material-ui/core/Grid'

import GalleryCarouselStyle from './galleryCarouselStyle.jsx'
import copy from '../../constants/copy.json'

const PlanCard = ({classes, item, isCurrentSlide}) => {

    return (
        <div className={classes.sliderContentPlan}>
            <Grid container alignContent='center' alignItems='center' justify='center' className={classes.comingSoonTitle}>
                {copy.progetti.projectPage.soluzioni}
            </Grid>
            <Grid container className={classes.sliderContentCardPlan} direction='column' justify='space-between'>
                <Grid container item className={classes.planImgContainer} justify='center' alignContent='center'>
                    <img src={item.full_image_url} alt='' style={{height: 'auto', maxWidth: '100%', maxHeight: '100%'}}/>
                </Grid> 
                <Grid container item className={classes.title} justify='center' align='center'>
                    {item.caption}
                </Grid>
            </Grid>
        </div>    
    );
}

export default withStyles(GalleryCarouselStyle)(PlanCard)